// extracted by mini-css-extract-plugin
export default {"notificationPosition":"userNotification_notificationPosition__Ww30O"};